import React, { useState } from 'react';
import { Sparkles, Gift, ChevronRight } from 'lucide-react';
import { useLoyaltySummary, useAvailableRewards } from '../../lib/loyalty-hooks';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
interface LoyaltyCardProps {
  phone: string;
  restaurantId: string | number | undefined;
}
export function LoyaltyCard({
  phone,
  restaurantId
}: LoyaltyCardProps) {
  const {
    summary,
    loading: summaryLoading
  } = useLoyaltySummary(phone, restaurantId);
  const {
    rewards,
    loading: rewardsLoading
  } = useAvailableRewards(phone, restaurantId);
  const [showRewards, setShowRewards] = useState(false);
  if (!phone || phone.length < 8) return null;
  if (summaryLoading) {
    return <div className="animate-pulse flex items-center gap-3 p-3 rounded-xl bg-gray-50 border border-gray-100 mt-2" data-id="element-1474">
        <div className="w-8 h-8 bg-gray-200 rounded-full" data-id="element-1475"></div>
        <div className="flex-1 space-y-2" data-id="element-1476">
          <div className="h-3 bg-gray-200 rounded w-1/3" data-id="element-1477"></div>
          <div className="h-2 bg-gray-200 rounded w-1/4" data-id="element-1478"></div>
        </div>
      </div>;
  }
  if (!summary) {
    return <div className="flex items-center gap-3 p-3 rounded-xl bg-brand-charcoal/5 border border-brand-charcoal/10 mt-2" data-id="element-1479">
        <div className="w-8 h-8 rounded-full bg-brand-charcoal/10 flex items-center justify-center shrink-0" data-id="element-1480">
          <Sparkles className="w-4 h-4 text-brand-charcoal" data-id="element-1481" />
        </div>
        <p className="text-sm text-gray-600 font-medium" data-id="element-1482">
          Con esta compra empiezas a acumular beneficios ✨
        </p>
      </div>;
  }
  const hasRewards = rewards && rewards.length > 0;
  return <>
      <div className="flex items-center justify-between p-3 rounded-xl bg-gradient-to-r from-[#1A1A1A] to-[#2A2A2A] border border-[#333] mt-2 shadow-sm" data-id="element-1483">
        <div className="flex items-center gap-3" data-id="element-1484">
          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0 border border-white/5" data-id="element-1485">
            <Sparkles className="w-5 h-5 text-[#F5E9DA]" data-id="element-1486" />
          </div>
          <div data-id="element-1487">
            <p className="text-sm font-bold text-white" data-id="element-1488">
              Tienes {summary.current_points || 0} puntos
            </p>
            <p className="text-xs text-white/70 font-medium" data-id="element-1489">
              Nivel {summary.current_level || 'Inicial'}
            </p>
          </div>
        </div>

        {hasRewards && <button type="button" onClick={() => setShowRewards(true)} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 transition-colors border border-white/10" data-id="element-1490">
            <Gift className="w-4 h-4 text-[#F5E9DA]" data-id="element-1491" />
            <span className="text-xs font-bold text-white" data-id="element-1492">
              {rewards.length}{' '}
              {rewards.length === 1 ? 'beneficio' : 'beneficios'}
            </span>
            <ChevronRight className="w-4 h-4 text-white/50" data-id="element-1493" />
          </button>}
      </div>

      <Modal isOpen={showRewards} onClose={() => setShowRewards(false)} title="Tus Beneficios Disponibles" data-id="element-1494">
        <div className="space-y-3 mt-4" data-id="element-1495">
          {rewards.map((reward: any) => <div key={reward.id} className="p-4 rounded-xl border border-gray-200 bg-gray-50 flex items-center justify-between gap-4" data-id="element-1496">
              <div data-id="element-1497">
                <h4 className="font-bold text-gray-900" data-id="element-1498">
                  {reward.reward_name}
                </h4>
                <p className="text-sm text-gray-500" data-id="element-1499">
                  Válido hasta{' '}
                  {new Date(reward.expires_at).toLocaleDateString()}
                </p>
              </div>
              <div className="shrink-0" data-id="element-1500">
                <Gift className="w-6 h-6 text-brand-charcoal" data-id="element-1501" />
              </div>
            </div>)}
          <div className="pt-4" data-id="element-1502">
            <Button className="w-full" onClick={() => setShowRewards(false)} data-id="element-1503">
              Entendido
            </Button>
          </div>
        </div>
      </Modal>
    </>;
}